import { Error } from './error'

export enum VoiceRepeat {
  AUTO_PLAY_ON,
  AUTO_PLAY_OFF,
}

export enum VoiceOrder {
  ORDER_TYP_RELEASE,
  ORDER_TYP_RANKING,
  ORDER_TYP_RANDOM,
  ORDER_TYP_REPEAT,
}

export enum VoiceRead {
  READ_PLAY_ON,
  READ_PLAY_OFF,
}

export interface PostVoiceSettingResponse {
  result: boolean
  error?: Error
}

export interface GetVoiceSettingResponse {
  result: boolean
  error?: Error
  repeat?: VoiceRepeat
  order?: VoiceOrder
  read?: VoiceRead
}

interface Author {
  id: number
  name: string
  ord: number
}
export interface GetVoiceNextResponse {
  result: boolean
  summary?: {
    id?: number
    title?: string
    image?: string
    voice?: string
    authors?: Author[]
  }
}
